import { render, staticRenderFns } from "./ArtistHeaderPreview.vue?vue&type=template&id=11152fb1&"
import script from "./ArtistHeaderPreview.vue?vue&type=script&lang=js&"
export * from "./ArtistHeaderPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports